import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const ResouceCategoryTemplateContainer = styled.div`
  max-width: 100vw !important; // used important to override layout max-width
  padding: 5rem 0 1.5rem;
`

export const ResourceCategoryTemplateContent = styled.div`
  max-width: 1229px;
  display: grid;
  margin-left: auto;
  margin-right: auto;
  justify-self: center;
  padding: 5rem 1.5rem;
`

export const ResourceCategoryTemplateActions = styled.div`
  display: grid;
  margin-left: auto;
  margin-right: auto;
  justify-self: center;
  margin-top: 1rem;
`

export const ResouceCategoryArticleList = styled.div`
  display: grid;
  column-gap: 2rem;
  row-gap: 3.1rem;
  margin: 2rem 0rem 2rem;
  grid-template-columns: 1fr 1fr 1fr;

  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 1fr;
    row-gap: 2rem;
  }
`
